export const labelResources = {
  'label.FCLabelDpiHelp':
    'Based on the configured carriers for this Fulfillment Center. We have compiled this list of valid DPIs',
  'label.FCLabelSizeHelp':
    'Based on the configured carriers for this Fulfillment Center. We have compiled this list of valid dimension/orientation combinations',
  'label.confirmAugmentationDelete': 'Are you sure you want to delete this augmentation?',
  'label.noFCsConfigured':
    'Cannot add labels until at least one carrier account is configured for the Fulfillment Center',
};

export type LabelResourceKey =
  | 'label.FCLabelDpiHelp'
  | 'label.FCLabelSizeHelp'
  | 'label.confirmAugmentationDelete'
  | 'label.noFCsConfigured';
